import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_SUBCATEGORIES_APP_PATHS } from '../constants/subcategories-app-paths.constants';
import AdminSubCategoriesListView from '../views/admin/AdminSubCategories.view';

export default function AdminSubcategoriesRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_SUBCATEGORIES_APP_PATHS.SUBCATEGORIES_LIST} component={AdminSubCategoriesListView} />
    </React.Fragment>
  );
}
